import { useDispatch, useSelector } from 'react-redux';

import dayjs, { Dayjs, OpUnitType } from 'dayjs';

import useAmplitudeContext from '@/hooks/useAmplitudeContext';
import { rulerDateRangeSet, selectRulerDateRange } from '@/store/calendar-navigation';
import { amplitudeEvents, dates } from '@/utils/constants';

export const useCalendar = () => {
    const dispatch = useDispatch();
    const rulerDateRange = useSelector(selectRulerDateRange);
    const { trackAmplitudeEvent } = useAmplitudeContext();

    const dispatchRulerRange = (startDay: Dayjs, endDay: Dayjs) => {
        dispatch(rulerDateRangeSet([startDay.format(dates.format), endDay.format(dates.format)]));
        trackAmplitudeEvent(amplitudeEvents.RULER_CLICK, {
            startDate: startDay.format(dates.format),
            endDate: endDay.format(dates.format),
        });
    };

    //eslint-disable-next-line unicorn/consistent-function-scoping
    const createDaysArray = (startDay: Dayjs, arrayLength: number, startsOf: OpUnitType = 'week') => {
        const dates = [];
        for (let i = 0; i < arrayLength; i++) {
            const currentDate = startDay.startOf(startsOf).add(i, 'day');
            dates.push(currentDate);
        }
        return dates;
    };

    const selectedDays = [dayjs(rulerDateRange[0]), dayjs(rulerDateRange[1])];

    const handleSelectDay = (day: Dayjs) => {
        const utcDayStart = day.utc().startOf('day');
        const utcDayEnd = day.utc().endOf('day');

        dispatchRulerRange(utcDayStart, utcDayEnd);
    };

    const todayHandler = () => {
        handleSelectDay(dates.today);
    };

    const handleSelectRange = (date: Dayjs) => {
        const utcDate = date.utc();

        if (date.isAfter(selectedDays[0]) && date.isBefore(selectedDays[1])) {
            handleSelectDay(date);
            return;
        }
        if (date.isAfter(selectedDays[0])) {
            dispatchRulerRange(selectedDays[0], utcDate.endOf('day'));
        } else {
            dispatchRulerRange(utcDate.startOf('day'), selectedDays[1]);
        }
    };

    //eslint-disable-next-line unicorn/consistent-function-scoping
    const checkIsDayOff = (day: Dayjs) => day.day() === 0 || day.day() === 6;

    return {
        selectedDays: selectedDays,
        handleSelectRange: handleSelectRange,
        checkIsDayOff: checkIsDayOff,
        handleSelectDay: handleSelectDay,
        todayHandler: todayHandler,
        today: dates.today,
        createDaysArray: createDaysArray,
    };
};
